import React from 'react';
import { useHistory } from 'react-router-dom';

import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function BreadCrumbs({ parentMenu, serviceMenu, menuItem, title, handleBack }) {
    const history = useHistory()

    return (
        <div className="space-y-3 h-breadcrumb">
            {/* BREADCRUMBS */}
            <div className="flex items-center text-gray-500 space-x-2">
                <div>{parentMenu ? parentMenu : "Parent Menu"}</div>
                {
                    serviceMenu &&
                    <>
                        <FontAwesomeIcon icon={faAngleRight} />
                        <div className={!menuItem ? "font-semibold" : ""}>{serviceMenu ? serviceMenu : "Service Menu"}</div>
                    </>
                }
                {
                    menuItem &&
                    <>
                        <FontAwesomeIcon icon={faAngleRight} />
                        <div className="font-semibold">{menuItem ? menuItem : "Menu Item"}</div>
                    </>
                }
            </div>

            <div className="flex items-center text-3xl font-bold space-x-4">
                {/* ARROW BACK */}
                {
                    menuItem &&
                    <button type="button" id="btnback" onClick={handleBack ? handleBack : history.goBack}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </button>
                }
                {/* TITLE */}
                <div>{title ? title : "Title"}</div>
            </div>
        </div>
    )
}

export default BreadCrumbs;